import TwitterIcon from 'react-scale/components/icons/Twitter';

const QuoteHighlight = ({ quote, author }) => (
  <div>
    <p className="text-4xl text-center lg:text-5xl font-aeonik text-gradient">
      &quot;{quote}&quot;
    </p>
    <div className="mt-16 text-center lg:mt-6">
      <button
        className="lg:text-lg"
        onClick={() =>
          window.open(
            encodeURI(
              `https://twitter.com/intent/tweet?text=${quote} - ${author} - ${window.location}`
            ),
            '',
            'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'
          )
        }
        type="button"
      >
        <TwitterIcon className="inline" fill="#86BFF2" width="24" height="24" />
        &nbsp; Share this on twitter
      </button>
    </div>
  </div>
);

export default QuoteHighlight;
